import { call, put } from 'redux-saga/effects';

import api from 'services';
import * as actionTypes from 'constants/ActionTypes';


/**
 * 
 * @param {'cargo' | 'vessel' | 'tc' | 'sales'} type 
 * @param {object} data 
 * @returns 
 */
export function* saveRequestsDataCreated(type, data) {
    const response = yield call(api.saveRequestsDataCreated, type, data);

    return response;
}

/**
 * 
 * @param {'cargo' | 'vessel' | 'tc' | 'sales'} type 
 * @param {{ _id: string }} data 
 * @returns 
 */
export function* saveRequestsDataDeleted(type, data) {
    const response = yield call(api.saveRequestsDataDeleted, type, data);

    return response;
}



// WEBPACK FOOTER //
// ./app/sagas/orders.js